define(["jquery", "storageservice", "togglestatekeeper"], function ($, storageService, toggleStateKeeper) {
    var instance = {
        triggerSelectors: '',
        initToggler: function (togglerObj, preventDefault) {
            //Sätt default-värde på detta sätt så fungerar det även i IE..
            if (preventDefault == null) {
                preventDefault = true;
            }

            //Klassen som ska läggas på vid öppnad yta
            var toggleClass = togglerObj.toggleClass;
            //Selectorerna som triggar öppning av yta
            triggerSelectors = togglerObj.triggerSelectors;
            //Container som måste innehålla target-selectorerna
            var targetContainerSelector = togglerObj.targetContainerSelector;
            //Selectorerna för ytor som ska öppnas
            var targetSelectors = togglerObj.targetSelectors;
            //Selectorerna för element som ska få aria-expanded. Behövs om man klickar på ett element (t ex en div) som inte får ha aria-expanded.
            var ariaExpandedElementSelectors = togglerObj.ariaExpandedSelectors;
            //Id till objektet i localStorage som kommer ihåg öppnade ytor
            var storedObjId = togglerObj.storedObjId;

            //Bind upp click samt toggle-state för alla triggers
            for (var i = 0; i < triggerSelectors.length; i++) {
                var triggerSelector = triggerSelectors[i];
                var $trigger = $(triggerSelector);

                

                //Lägg på aria-attribut
                var $ariaExpandedElement = $trigger;

                if (typeof (ariaExpandedElementSelectors) !== 'undefined' && ariaExpandedElementSelectors.length >= i + 1) {
                    var $ariaExpandedTarget = $(togglerObj.ariaExpandedSelectors[i]);

                    if ($ariaExpandedTarget.length > 0) {
                        $ariaExpandedElement = $ariaExpandedTarget;
                    }
                }

                instance.ariaDecoration($ariaExpandedElement, targetContainerSelector, targetSelectors, toggleClass);

                //Bind click-event and keyup-event (keyup only detected for element with click-catcher class)
                $trigger.on("click keyup", function (e) {
                    if (preventDefault) {
                        e.preventDefault();
                    }
                    if (e.type === "keyup" && (e.key !== "Enter" || triggerSelector !== ".click-catcher")) {
                        return;
                    }

                    instance.togglerClick($(this), targetContainerSelector, targetSelectors, toggleClass, storedObjId, ariaExpandedElementSelectors);
                });
            }

            //Läs in eventulla öppnade ytor
            var storedObj = storageService.getStoredItem(togglerObj.storedObjId, true);
            if (storedObj != null && storedObj.opened != null) {
                for (var j = 0; j < storedObj.opened.length; j++) {
                    var elementId = storedObj.opened[j].id;
                    //Trigga klicket för att öppna ytan
                    $("#" + elementId).trigger("click");
                }
            }


            //Dölj "visa mer" knapp om det saknas innehåll i visa mer ytan)
            if (targetContainerSelector.startsWith('.js-showmore-container'))
            {
                //Läs in ytor
                $(targetContainerSelector).each(function () {
                    var $showMorePanel = $(this).find('.showmore.showmore-3x-lineheight24');
                    if ($showMorePanel)
                    {
                        //Visa hela innehållsytan och dölj knappen om innehållsyta är mindre än 100px hög (maxheight = 84px + margin/padding)
                        var scrollHeight = $showMorePanel.prop('scrollHeight');
                        if (scrollHeight <= 100) {
                            var $showMoreButton = $(this).find('.popupbutton');
                            if ($showMoreButton) {
                                //Trigga klicket för att öppna ytan
                                $showMoreButton.trigger("click");
                                //Dölj knappen
                                $showMoreButton.addClass('hidden');
                            }
                        }
                    }
                });
            }
        },
        togglerClick: function ($trigger, targetContainerSelector, targetSelectors, toggleClass, storedObjId, ariaExpandedElementSelectors) {
            var isExpanded;
            $trigger.toggleClass(toggleClass);

            var $targetContainer = $trigger.closest(targetContainerSelector);

            //Leta upp varje aria-target i dess "scope" (targetContainer)
            if (ariaExpandedElementSelectors != null) {
                for (var j = 0; j < ariaExpandedElementSelectors.length; j++) {
                    var $ariaTargetElement = $targetContainer.find(ariaExpandedElementSelectors[j]);
                    isExpanded = instance.toggleBooleanAttribute($ariaTargetElement, "aria-expanded");

                    if (isExpanded && $ariaTargetElement.data("label-expanded")) {
                        $ariaTargetElement.attr("aria-label", $trigger.data("label-expanded"));
                    }
                    else if (!isExpanded && $ariaTargetElement.data("label-collapsed")) {
                        $ariaTargetElement.attr("aria-label", $trigger.data("label-collapsed"));
                    }
                }
            }

            //Leta upp varje target i dess "scope" (targetContainer)
            for (var i = 0; i < targetSelectors.length; i++) {
                var $target = $targetContainer.find(targetSelectors[i]);
                $target.toggleClass(toggleClass);
                instance.toggleBooleanAttribute($target, "aria-hidden");
                $target.toggleClass("rs_skip");
            }

            //För att kunna komma ihåg en öppnad yta måste triggern ha ett id
            //...och det måste finnas ett storedObjId angivet
            var elementId = $trigger.attr("id");
            if (typeof storedObjId !== "undefined" && elementId != null) {
                toggleStateKeeper.storeOpenedAreas(storedObjId, elementId, $trigger.hasClass(toggleClass));
            }
        },
        ariaDecoration: function ($trigger, targetContainerSelector, targetSelectors) {
            var $targetContainer = $trigger.closest(targetContainerSelector);

            var ariaExpanded = $trigger.attr("aria-expanded") === 'true';
            var ariaHidden = !ariaExpanded;
            $trigger.attr("aria-expanded", ariaExpanded);

            //Leta upp varje target i dess "scope" (targetContainer)
            for (var i = 0; i < targetSelectors.length; i++) {
                var $target = $targetContainer.find(targetSelectors[i]);
                $target.attr("aria-hidden", ariaHidden);
                $target.toggleClass("rs_skip", ariaHidden);
            }
        },
        toggleBooleanAttribute: function ($selector, attributeName) {
            var value = $selector.attr(attributeName);
            if (value === 'true') {
                value = 'false';
            } else {
                value = 'true';
            }

            $selector.attr(attributeName, value);

            return value === 'true';
        },
        show: function () {

            for (var i = 0; i < triggerSelectors.length; i++) {
                var triggerSelector = triggerSelectors[i];
                $(triggerSelector).trigger("click");
            }
        },
    };

    return instance;
});